
<ng-template #content let-modal>
  <div class="modal-body">
    <div class="app-header-wrapper">
      <div class="col-12 app-header-nav">
        <input type="text" name="search" (change)="searchGlobal(search)" [(ngModel)]="search" placeholder="Buscar"
          class="form-control search-bar">
        <a class="btn-search" (click)="modal.dismiss('Cross click')">
          <svg xmlns="http://www.w3.org/2000/svg" width="46.669" height="46.669" viewBox="0 0 46.669 46.669">
            <g id="close" transform="translate(-41.665 -25.665)">
              <rect id="Rectángulo_3" data-name="Rectángulo 3" width="60" height="6"
                transform="translate(45.908 25.665) rotate(45)" fill="#fff" />
              <rect id="Rectángulo_41" data-name="Rectángulo 41" width="60" height="6"
                transform="translate(88.334 29.908) rotate(135)" fill="#fff" />
            </g>
          </svg>
        </a>
      </div>
      <div class=" app-search-wrapper">
        <div class="col-12" *ngIf="!searched">
          <h2 class="centered">¿Qué estas buscando?</h2>
        </div>
        <div class="col-12" *ngIf="searched">
          <h2 *ngIf="ready ==true && searched.length==0">Lo sentimos no encontramos resultados para "{{search}}"</h2>
          <h2 *ngIf="ready ==true && searched.length> 0">Resultados encontrados</h2>
          <ul class="search-results" *ngFor="let item of searched">
            <li class="search-results-item" (click)="route.goTo(item.fullroute); modal.dismiss()">
              <h4>{{item.title}}</h4>
              <div class="btn-plus">
                <svg xmlns="http://www.w3.org/2000/svg" width="40.001" height="40" viewBox="0 0 40.001 40">
                  <path id="ver-mas" d="M17.5-7850v-17.5H0v-5H17.5V-7890h5v17.5H40v5H22.5v17.5Z"
                    transform="translate(0 7890)" fill="#fff" />
                </svg>
              </div>
            </li>

          </ul>

        </div>
      </div>
    </div>


  </div>
</ng-template>
